var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhotoinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 3H1v1h4V3ZM0 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4H6V2H0Zm1 20V5h22v17a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM18.5 7h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Zm-1.5.5A1.5 1.5 0 0 1 18.5 6h2a1.5 1.5 0 0 1 0 3h-2A1.5 1.5 0 0 1 17 7.5ZM16 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm1 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
  fill: "#252829"
})));
export default SvgPhotoinline;